// React dependencies
import React, { useState, useEffect } from 'react';

// External dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Paper } from '@material-ui/core';

// Internal dependencies
import { Status } from '../../../../common/constants';
import CreditCardsList from './CreditCardsList';
import postStyle from '../../../../styles/post';
import OtherPartners from './OtherPartners';
import Colours from '../../../../styles/colours';
import MText from '../../../../components/Common/MText';

const Partnerships = (props) => {
  const [disableInputFields, setDisableInputFields] = useState(false);

  useEffect(() => {
    if (props && props.post) {
      const p = props.post;
      setDisableInputFields([Status.Live, Status.Paused].includes(p.currentPostStatus));
    }
  }, [props.post]);
  return (
    <>
      <Paper variant="elevation" className="px-5 pt-4" style={postStyle.paper}>
        <MText className="mt-3 mb-3" style={postStyle.textHeader}>
          Credit Cards
        </MText>

        <CreditCardsList
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          disabled={disableInputFields}
          disabledMsg={`Cannot be updated because post is ${props.post.currentPostStatus}`}
        />

        <MText className="mt-4" style={postStyle.textHeader}>
          Others
        </MText>
        <MText
          className="mb-2"
          text="E.g. For partnership with a brand, enter the brand's name"
          textSize={11}
          colour={Colours.Gray}
        />

        <OtherPartners disabled={disableInputFields} disabledMsg={`Cannot be updated because post is ${props.post.currentPostStatus}`} />
      </Paper>
    </>
  );
};

Partnerships.propTypes = {
  post: PropTypes.shape({
    promoAvailOnlineAt: PropTypes.string,
    currentPostStatus:  PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  page: state.page.selected,
});

export default connect(mapStateToProps, null)(Partnerships);
